import { loadStripe } from "@stripe/stripe-js";

const stripePublishableKey = process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

let stripePromise;

// Stripe.js can fail to load because of network conditions or browser privacy
// tools. Resolve to null so Elements can remain mounted without an unhandled
// promise rejection; the payment forms already disable themselves until Stripe
// is available. Loading is deferred until a billing component needs it so
// unrelated pages do not request Stripe.js.
export const getStripePromise = () => {
  if (!stripePromise) {
    stripePromise = stripePublishableKey
      ? Promise.resolve()
          .then(() => loadStripe(stripePublishableKey))
          .catch(() => null)
      : Promise.resolve(null);
  }

  return stripePromise;
};
